<div class="eye-view-details">
  @if(jobDetails){
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Job Number
    </div>
    <div class="col-7 eye-view-details-content">
      {{ jobDetails.jobNumber}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Freight Payer
    </div>
    <div class="col-7 eye-view-details-content">
      {{ jobDetails.freightPayer?.name || ""}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Required Date
    </div>
    <div class="col-7 eye-view-details-content">
      {{ jobDetails.requiredDate | date: 'dd/MM/yyyy'}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Estimated Time
    </div>
    <div class="col-7 eye-view-details-content">
      {{ getEstimatedTime() }}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Loading Service Promise
    </div>
    <div class="col-7 eye-view-details-content">
      {{getServicePromise(jobDetails.jobLsp, jobDetails.jobLspTime)}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Delivery Service Promise
    </div>
    <div class="col-7 eye-view-details-content">
      {{getServicePromise(jobDetails.jobDsp, jobDetails.jobDspTime)}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Priority
    </div>
    <div class="col-7 eye-view-details-content">
      {{ getJobPriority() }}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end eye-view-details-header">
      Job Reference
    </div>
    <div class="col-7 eye-view-details-content">
      {{ jobDetails.jobReference}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Job Description
    </div>
    <div class="col-7 eye-view-details-content">
      {{ jobDetails.jobDescription}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Job Comments
    </div>
    <div class="col-7 eye-view-details-content">
      {{ jobDetails.jobComments}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Driver Notes
    </div>
    <div class="col-7 eye-view-details-content">
      {{ jobDetails.driversNotes}}
    </div>
  </div>
  <div class="row eye-view-details-row">
    <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
      Equipment
    </div>
    <div class="col-7 eye-view-details-content">
      {{ getJobEquipments() }}
    </div>
  </div>
  }
</div>